export default __webpack_public_path__ + "8e70d1449f23c65fd3f473bdd12e2cde.png";